import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { useAuthorization } from "@hooks";

import {
  ROUTES,
  ADMIN_NAV,
  ADMIN_NAV_MY_PROFILE,
  COMPANY,
  CUSTOMER,
} from "@utils/constant";
import { isAdminUser, isAuthenticated } from "@utils/utils";

export const useLoginRedirection = () => {
  const { hasAnyPermissions } = useAuthorization();
  const history = useHistory();
  const { userInfo: { type: userType, customer = {} } = {} } = useSelector(
    state => state.authReducer
  );

  const findPath = React.useCallback(() => {
    const [{ redirectTo: fallbackUrl }] = ADMIN_NAV_MY_PROFILE;
    const { redirectTo: targetRedirectUrl } =
      ADMIN_NAV.find(({ permissions = [] }) =>
        hasAnyPermissions(permissions)
      ) ?? {};

    return targetRedirectUrl ?? fallbackUrl;
  }, [hasAnyPermissions]);

  React.useEffect(() => {
    if (!isAuthenticated()) {
      return;
    }

    const redirectTarget = ROUTES.USER_PROFILE.URL;

    if (isAdminUser()) {
      history.replace(findPath());
    } else if (userType === CUSTOMER && customer.type === COMPANY) {
      history.replace(ROUTES.SEARCH.URL);
    } else {
      history.replace(redirectTarget);
    }
  }, [customer.type, findPath, history, userType]);
};
